/*
 * This is based on
 * https://ui.reach.tech/menu-button
 *
 */

import { querySelectArray } from './utils';

const InitMenuButtons = () => {
    const buttons = querySelectArray('[data-menubutton-ref]', document);
    buttons.forEach(initMenuButton);
};

const initMenuButton = menuButton => {
    const menuContentRef = menuButton.getAttribute('data-menubutton-ref');
    menuButton.classList.remove('u-hide');
    menuButton.classList.add('u-hide@mediumdown');

    const menuContent = document.querySelector(menuContentRef);
    let menuItems;
    refreshMenuItems();
    const buttonRect = menuButton.getBoundingClientRect();
    menuContent.style.left = `${buttonRect.left}px`;

    menuButton.addEventListener('click', onMenuButtonClick, false);
    menuButton.addEventListener('keydown', onMenuButtonKeyDown, false);
    menuContent.addEventListener('keydown', menuContentKeyDown, false);
    document.body.addEventListener('click', clickOutside, false);

    let state = {
        isOpen: false,
    };

    function refreshMenuItems() {
        menuItems = querySelectArray('[role="menuitem"]', menuContent);
    }

    function onMenuButtonClick(e) {
        e.stopPropagation(); // so that we don't bubble up to 'clickOutside'
        const rect = menuButton.getBoundingClientRect();
        menuContent.style.left = `${rect.left}px`;
        const isClickFromKeyboard = e.clientX === 0;
        state = {
            ...state,
            isOpen: !state.isOpen,
            focusIndex: !state.isOpen && isClickFromKeyboard ? 0 : false,
            setFocusToButton: false,
        };
        render();
    }

    function clickOutside() {
        state = {
            ...state,
            isOpen: false,
            focusIndex: false,
            setFocusToButton: false,
        };
        render();
    }

    function onMenuButtonKeyDown(e) {
        if (
            [
                'Down', // IE/Edge specific value
                'ArrowDown', // W3C
            ].indexOf(e.key) !== -1
        ) {
            state = {
                ...state,
                isOpen: true,
                focusIndex: 0,
                setFocusToButton: false,
            };
            e.preventDefault(); // prevent scrolling
            render();
        } else if (e.key === 'Escape') {
            state = {
                ...state,
                isOpen: false,
                focusIndex: false,
                setFocusToButton: true,
            };
            render();
        }
    }

    function menuContentKeyDown(e) {
        refreshMenuItems();
        switch (e.key) {
            case 'Down': // IE/Edge specific value
            case 'ArrowDown': // W3C
                // Down
                e.preventDefault(); // prevent scrolling
                state = {
                    ...state,
                    isOpen: true,
                    focusIndex: Math.min(
                        menuItems.length - 1,
                        state.focusIndex + 1,
                    ),
                    setFocusToButton: false,
                };
                render();
                break;
            case 'Up': // IE/Edge specific value
            case 'ArrowUp': // W3C
                e.preventDefault(); // prevent scrolling
                state = {
                    ...state,
                    isOpen: true,
                    focusIndex: Math.max(0, state.focusIndex - 1),
                    setFocusToButton: false,
                };
                render();
                break;
            case 'Escape':
                state = {
                    ...state,
                    isOpen: false,
                    focusIndex: false,
                    setFocusToButton: true,
                };
                render();
                break;
            case 'Tab':
                e.preventDefault(); // prevent nav
                break;
            default:
                break;
        }
    }

    function render() {
        refreshMenuItems();
        menuButton.setAttribute('aria-expanded', state.isOpen.toString());
        menuContent.style.display = state.isOpen ? 'block' : 'none';
        if (state.focusIndex !== false) {
            const menuItem = menuItems[state.focusIndex];
            if (!menuItem) {
                // out of bounds menu access so leave current item focused
                return;
            }
            menuItem.focus();
        } else if (state.setFocusToButton === true) {
            menuButton.focus();
        }
    }
};

export default InitMenuButtons;
